import React, { useState, useEffect } from "react";
import Selector from "./selector";

const Radiobutton = (props) => {
  return <Selector className={"radiobutton"} {...props} />;
};

export default Radiobutton;
